<template>
  <div class="list_message">
    <div class="top">
      <span class="name">{{record.activityTheme}}</span>
      <div class="state"><span>{{record.busiManageTypeName}}</span></div>
    </div>
    <div class="body" v-if="record.busiManageTypeCode == 1">
     
      <p class="content">
        <span class="title">活动类型：</span>
        <span class="obj">{{record.busiManageTypeName}}</span>
      </p>
      <p class="content">
        <span class="title">赴外单位：</span>
        <span class="obj">{{record.orgName}}</span>
      </p>
      <p class="content">
        <span class="title">赴外时间：</span>
        <span class="obj">{{record.overDate}} {{record.residentBackDate && record.overDate ? '~':''}} {{record.residentBackDate}}</span>
      </p>
      <p class="content">
        <span class="title">创建时间：</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
      
    </div>
    <div class="body" v-if="record.busiManageTypeCode == 2">
     
      <p class="content">
        <span class="title">活动类型：</span>
        <span class="obj">{{record.busiManageTypeName}}</span>
      </p>
      <p class="content">
        <span class="title">接待单位：</span>
        <span class="obj">{{record.orgName}}</span>
      </p>
      <p class="content">
        <span class="title">来滇企业：</span>
        <span class="obj">{{record.companyName}}</span>
      </p>
      <p class="content">
        <span class="title">来滇时间：</span>
        <span class="obj">{{record.overDate}} {{record.residentBackDate && record.overDate ? '~':''}} {{record.residentBackDate}}</span>
      </p>
      <p class="content">
        <span class="title">创建时间：</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
      
    </div>
    <div class="body" v-if="record.busiManageTypeCode == 3">
      
      <p class="content">
        <span class="title">活动类型：</span>
        <span class="obj">{{record.busiManageTypeName}}</span>
      </p>
      <p class="content">
        <span class="title">接待单位：</span>
        <span class="obj">{{record.orgName}}</span>
      </p>
      <p class="content">
        <span class="title">客商名称：</span>
        <span class="obj">{{record.companyName}}</span>
      </p>
      <p class="content">
        <span class="title">会面时间：</span>
        <span class="obj">{{record.overDate}} {{record.residentBackDate && record.overDate ? '~':''}} {{record.residentBackDate}}</span>
      </p>
      <p class="content">
        <span class="title">创建时间：</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
      
    </div>
    <div class="body" v-if="record.busiManageTypeCode == 4">
      <table>
        <tr class="content">
          <td class="title">活动类型：</td>
          <td class="obj">{{record.busiManageTypeName}}</td>
        </tr>
        <tr class="content">
          <td class="title">驻派人员单位：</td>
          <td class="obj">{{record.orgName}}</td>
        </tr>
        <tr class="content">
          <td class="title">驻派人员：</td>
          <td class="obj">{{record.merchants}}</td>
        </tr>
        <tr class="content">
          <td class="title">驻派时间：</td>
          <td class="obj">{{record.overDate}} {{record.residentBackDate && record.overDate ? '~':''}} {{record.residentBackDate}}</td>
        </tr>
        <tr class="content">
          <td class="title">创建时间：</td>
          <td class="obj">{{record.createTime}}</td>
        </tr>
      </table>
      
      
    </div>
    <div class="body" v-if="record.busiManageTypeCode == 5">
      
      <p class="content">
        <span class="title">活动类型：</span>
        <span class="obj">{{record.busiManageTypeName}}</span>
      </p>
      <p class="content">
        <span class="title">参加单位：</span>
        <span class="obj">{{record.orgName}}</span>
      </p>
      <p class="content">
        <span class="title">活动时间：</span>
        <span class="obj">{{record.overDate}} {{record.residentBackDate && record.overDate ? '~':''}} {{record.residentBackDate}}</span>
      </p>
      <p class="content">
        <span class="title">创建时间：</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
      
    </div>
    <div class="foot">
      <span  @click="$router.push({path: '/investment/activityDetails',query:{id:record.id}})">查看详情</span>
      <img  @click="$router.push({path: '/investment/activityDetails',query:{id:record.id}})" src="../../../assets/investment/jinru.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "listActivity",
  components: {},
  props: {
    record:{
      id:'',
      activityTheme:'',
      orgName:'',
      overDate: '',
      createTime:''
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    console.log(this.record)
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.list_message {
    background: #FFFFFF;
    padding: 12px 20px;
    border-radius: 3px;
    margin-top: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
    word-break:break-all;
    .top{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .name{
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .state{
        margin-left: 20px;
        white-space: nowrap;
        display: inline-block;
        font-size: 12px;
        line-height: 14px;
        background: rgba(34, 131, 230, 0.1);
        color: #2283E6;
        padding: 2px 4px;
        border-radius: 1px;
        span{
          display: inline-block;
          margin-top: 2px;
          transform: scale(0.8333);
        }
      }
      
    }
    .body{
      padding-top: 12px;
      border-bottom: 0.5px solid #EEEEEE;

      .content{
        margin-bottom: 12px;
        line-height: 17px;
        color: #333333;
      }
      table {
        table-layout: fixed;
        max-width: 100%;
        word-wrap: break-word;
        text-overflow: ellipsis;
        td {
          padding-bottom: 12px;
          // padding-right: 8px;
          vertical-align: top;
          white-space: normal;
        }
        .title {
          white-space: nowrap;
          margin-right: 8px;
        }
      }
    }
    .foot{
      padding-top: 12px;
      
      span{
        display: inline-block;
        color: #36B374;
        line-height: 17px;
        font-size: 12px;
      }
      img{
        display: inline-block;
        width: 4px;
        height: 8px;
        margin-left: 5px;
      }
    }
}
</style>